import React from "react";
import { Avatar, Typography, Box } from "@mui/material";
import { getUserName } from "../../Features/Authentication/authSlice";
import { useSelector } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch } from "react-redux";
import { logout } from "../../Features/Authentication/authSlice";
import Divider from "@mui/material/Divider";
import Logout from "@mui/icons-material/Logout";
import { ListItemIcon } from "@mui/material";

function initials(name) {
  if (!name) return "OP";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

function UserCard() {
  const user_name = useSelector(getUserName);
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "10px", px: "4px", py: "2px" }}>
      <Avatar sx={{ width: 30, height: 30, backgroundColor: "#FDB940", color: "#0d1117", fontWeight: 700, fontSize: "0.78rem" }}>
        {initials(user_name)}
      </Avatar>
      <Typography sx={{ color: "#fff", fontSize: "0.88rem", fontWeight: 500 }}>{user_name}</Typography>
    </Box>
  );
}

export default function ProfileDropDown() {
  const dispatch = useDispatch();
  const user_name = useSelector(getUserName);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogout = () => { dispatch(logout()); setAnchorEl(null); };

  return (
    <div>
      <Avatar
        onClick={handleClick}
        sx={{
          width: 32,
          height: 32,
          backgroundColor: "#FDB940",
          color: "#0d1117",
          fontWeight: 700,
          fontSize: "0.82rem",
          cursor: "pointer",
          ml: "8px",
        }}
      >
        {initials(user_name)}
      </Avatar>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        sx={{ zIndex: 2300 }}
        PaperProps={{
          sx: {
            backgroundColor: "#1C232C",
            border: "1px solid rgba(255,255,255,0.12)",
            mt: "6px",
            minWidth: 180,
          },
        }}
      >
        <MenuItem disableRipple sx={{ "&:hover": { bgcolor: "transparent" }, cursor: "default" }}>
          <UserCard />
        </MenuItem>
        <Divider sx={{ borderColor: "rgba(255,255,255,0.08)", my: "4px" }} />
        <MenuItem
          onClick={handleLogout}
          sx={{ color: "rgba(255,255,255,0.65)", fontSize: "0.88rem", "&:hover": { bgcolor: "rgba(255,255,255,0.05)", color: "#fff" } }}
        >
          <ListItemIcon>
            <Logout fontSize="small" sx={{ color: "rgba(255,255,255,0.55)" }} />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </div>
  );
}
